import {
  actionButtonNavigationConfigType,
  ActionButtonOutcomesType,
  defaultNavigationConfig,
} from '../action-button-navigation-config.type';
import { ButtonActionType } from '../common.type';

export const documentNavigationConfigMap: Map<ButtonActionType, actionButtonNavigationConfigType> = new Map([
  [
    ButtonActionType.DELETE_DOCUMENT,
    {
      [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
      [ActionButtonOutcomesType.PROCESSING]: defaultNavigationConfig,
      [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
    },
  ],
  [
    ButtonActionType.VIEW_DOCUMENT,
    {
      [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
    },
  ],
  [
    ButtonActionType.DOWNLOAD_DOCUMENT,
    {
      [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
      [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
    },
  ],
]);
